import { CommissionWorkspace } from "./CommissionDashboard";
export default function MyCommissions() {
  return <CommissionWorkspace mine />;
}
